// removed by extract-text-webpack-plugin
module.exports = {"carouselHeader":"CarouselHeader__carouselHeader___2ROa5","labelHeader":"CarouselHeader__labelHeader___cA5_J","secondHeaderLabel":"CarouselHeader__secondHeaderLabel___LL7D- CarouselHeader__labelHeader___cA5_J","headerDiv":"CarouselHeader__headerDiv___Thy2O","secondheaderDiv":"CarouselHeader__secondheaderDiv___2lwkl CarouselHeader__headerDiv___Thy2O","headerClose":"CarouselHeader__headerClose___14EFQ","closeButton":"CarouselHeader__closeButton___CL__G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarouselHeader/CarouselHeader.css
// module id = 988
// module chunks = 0